import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const CareersOuttro = () => {
  const t = useTranslations();

  return (
    <section data-cy="careers-outro">
      <LayoutGrid rowGap={24}>
        <Typography
          variant="h1"
          weight="light"
          height="tight"
          className="col-main w-3/4 lg:col-start-4 lg:w-full xl:col-start-7"
        >
          {t('want_to_learn_more')}
        </Typography>
        <Typography className="col-main col-start-4 lg:col-start-9 lg:col-end-14 xl:col-end-15">
          {t('theres_a_lot_to_learn')}
        </Typography>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 4, lg: 9 }}>
          <Button href="/about-us" variant="secondary-dark">
            {t('about_us')}
          </Button>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CareersOuttro;
